import { render } from "./EducationalAlerts.vue?vue&type=template&id=2906646f&scoped=true"
import script from "./EducationalAlerts.vue?vue&type=script&lang=js"
export * from "./EducationalAlerts.vue?vue&type=script&lang=js"

import "./EducationalAlerts.vue?vue&type=style&index=0&id=2906646f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2906646f"]])

export default __exports__